// apps/admin/src/hooks/useAdvertisementMediasByAdId.ts

import { ApiResponse, AdvertisementWithMedia } from '@magnetar/admin-api-interfaces'
import { useAuth } from './useAuth'
import { useGet } from './useFetch'

export function useAdvertisementMediasByAdId(
  supplierId: number | undefined,
  advertisementId: number | undefined,
) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<ApiResponse<AdvertisementWithMedia>>(
    token && advertisementId
      ? `/api/ad-supplier/${supplierId}/advertisements/${advertisementId}`
      : null,
    undefined,
    token ?? '',
  )

  return {
    medias: data?.data?.media ?? [],
    advertisement: data?.data,
    isLoading,
    isError: error,
    mutate,
  }
}
